import { FleetType, Site } from '@jucy-ui/common';
import { getSiteSettings } from './getSiteSettings';

export const getBranchSupportsFleetType = ({ branch, fleetType }: { branch: Site; fleetType: FleetType }) =>
    Boolean(getSiteSettings({ branch, fleetType }));
